import type { Element } from "React";
type Props = {
  className?: string;
};

const IconGalaxyBet = (props: Props): Element<"svg"> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 32 32"
    className={props.className}
  >
    <g
      transform="translate(0.000000,32.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M86 295 c-15 -14 -33 -25 -41 -25 -8 0 -17 -5 -21 -11 -5 -8 1 -10
20 -7 30 6 30 6 12 -46 -8 -22 -12 -52 -9 -68 5 -30 -13 -38 -35 -16 -9 9 -12
8 -12 -4 0 -8 7 -21 16 -28 8 -8 23 -30 32 -49 l16 -36 4 32 c3 33 3 33 32 18
16 -8 48 -15 71 -15 36 0 41 -2 36 -20 -5 -21 7 -27 19 -9 3 6 22 17 40 25 40
17 45 33 9 26 -28 -5 -30 2 -10 38 8 14 14 44 15 68 0 43 7 51 28 30 9 -9 12
-8 12 5 0 9 -8 21 -19 26 -10 6 -21 24 -24 41 -4 16 -10 30 -15 30 -5 0 -7
-11 -4 -25 5 -27 -7 -32 -39 -15 -10 6 -36 11 -56 12 -49 1 -55 5 -43 29 15
27 -2 24 -34 -6z"
      />
    </g>
  </svg>
);

export default IconGalaxyBet;
